import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const PaymentStatusNotAuthorized = (props) => {
  const _themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Non autorisé</title>
        <path
          d="M13.3781 11.9533L13.3781 3.00759L17 3.00759L17 11.9533L13.3781 11.9533ZM13.3781 11.9533L8.6719 17.3754C8.22589 17.8918 7.52612 18.1121 6.8571 17.945L6.81096 17.945C5.59597 17.6336 5.04999 16.2363 5.74207 15.2036L7.94137 11.9457L3.81192 11.9457C2.66614 11.9457 1.81257 10.9129 2.03557 9.80422L3.11984 4.43526C3.28902 3.59992 4.03493 3 4.89619 3L13.3781 3"
          stroke="#CB1517"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default PaymentStatusNotAuthorized;
